<script lang="ts">
	import { Popover as PopoverPrimitive } from 'bits-ui'

	let {
		ref = $bindable(null),
		class: className,
		...restProps
	}: PopoverPrimitive.TriggerProps = $props()
</script>

<PopoverPrimitive.Trigger class={className} data-slot="popover-trigger" bind:ref {...restProps} />
